import React, { Suspense } from "react";
import TopRangeLoader from "../components/TopRangeLoader";
import ScrollToTop from "../components/ScrollToTop";


function TopRangeIndex() {

  const TopRangeNavbar = React.lazy(() => import('../components/TopRangeNavbar'));
  const TopRangeHeader = React.lazy(() => import('../components/TopRangeHeader'));
  const TopRangeCompanyOverview = React.lazy(() => import('./index-sections/TopRangeCompanyOverview'));
  const TopRangeServicesOverview = React.lazy(() => import('./index-sections/TopRangeServicesOverview'));
  const TopRangeProductsOverview = React.lazy(() => import('./index-sections/TopRangeProductsOverview'));
  const TopRangeCareer = React.lazy(() => import('./index-sections/TopRangeCareer'));
  const TopRangeAdditionalInfo = React.lazy(() => import('./index-sections/TopRangeAdditionalInfo'));
  const TopRangeContacts = React.lazy(() => import('../components/TopRangeContacts'));
  const TopRangeFooter = React.lazy(() => import('../components/TopRangeFooter'));

  return (
    <Suspense fallback={<TopRangeLoader />}>
      <TopRangeNavbar />
      <TopRangeHeader />
      <div className="main">
        <TopRangeCompanyOverview />
        <TopRangeServicesOverview />
        <TopRangeProductsOverview />
        <TopRangeCareer />
        <TopRangeAdditionalInfo />
        <TopRangeContacts />
      </div>
      <TopRangeFooter />
      <ScrollToTop />
    </Suspense>
  );
}

export default TopRangeIndex;